/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `invalidity` - Invalidity
 * * `death` - Death
 * * `traumatism` - Traumatism
 * * `outpatient_daily_allowance` - Outpatient Daily Allowance
 * * `inpatient_daily_allowance` - Inpatient Daily Allowance
 * * `all_main_risks` - All Main Risks
 * * `sudden_death_financial_loss` - Sudden Death Financial Loss
 * * `repatriation_financial_loss` - Repatriation Financial Loss
 * * `passenger_travel_accident` - Passenger Travel Accident
 * * `driver_accident` - Driver Accident
 */
export enum AccidentRiskCategory {
  INVALIDITY = 'invalidity',
  DEATH = 'death',
  TRAUMATISM = 'traumatism',
  OUTPATIENT_DAILY_ALLOWANCE = 'outpatient_daily_allowance',
  INPATIENT_DAILY_ALLOWANCE = 'inpatient_daily_allowance',
  ALL_MAIN_RISKS = 'all_main_risks',
  SUDDEN_DEATH_FINANCIAL_LOSS = 'sudden_death_financial_loss',
  REPATRIATION_FINANCIAL_LOSS = 'repatriation_financial_loss',
  PASSENGER_TRAVEL_ACCIDENT = 'passenger_travel_accident',
  DRIVER_ACCIDENT = 'driver_accident',
}
